export const getActiveRecommendation = (state) => state.recommendations.recommendation;
